export const isWacRoutingSignalWae = (headerValue: unknown): boolean => {
	if (Array.isArray(headerValue)) {
		return headerValue.some(isWacRoutingSignalWae);
	}

	return typeof headerValue === 'string' && headerValue.trim().toLowerCase() === 'wae';
};
